window.addEventListener('load', function() {
    setBikeToggles();
});

function setBikeToggles() {
    const bikeToggles = Array.from(document.querySelectorAll('.service-bike-toggle'));

    if (bikeToggles && bikeToggles.length > 0) {
        bikeToggles.forEach((toggle) => {
            const bikeElements = Array.from(toggle.parentElement.parentElement.querySelectorAll('.service-bike-toggle-field'));
            const checkboxes = Array.from(toggle.querySelectorAll('input[type="checkbox"]'));

            if (checkboxes && checkboxes.length > 0) {
                if (checkboxes[0].checked) {
                    setBikeElements(true, bikeElements, false);
                }

                checkboxes[0].addEventListener('change', function() {
                    if (this.checked) {
                        setBikeElements(true, bikeElements, true);
                    } else {
                        setBikeElements(false, bikeElements, true);
                    }
                });
            }
        });
    }
}

function setBikeElements(show, bikeElements, reset) {
    if (bikeElements && bikeElements.length > 0) {
        bikeElements.forEach((element) => {
            if (reset) resetInputs(element);

            if (show) {
                element.classList.remove('d-none');
            } else {
                element.classList.add('d-none');
            }
        })
    }
}

function resetInputs(element) {
    const nodes = Array.from(element.childNodes);
    if (nodes && nodes.length > 0) {
        nodes.forEach((node) => {
            if (node.tagName === 'INPUT') {
                node.value = '';
            } else if (node.tagName === 'SELECT') {
                node.selectedIndex = 0;
            }
        });
    }
}
